import { FlowDurationSchema, FlowFormCompletionWorkflowSignals } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const WaitForFormCompletionBlockConfigSchema = z.object({
  signalName: z.enum(FlowFormCompletionWorkflowSignals),
  timeout: FlowDurationSchema,
});
export type WaitForFormCompletionBlockConfig = z.infer<
  typeof WaitForFormCompletionBlockConfigSchema
>;

export const WaitForFormCompletionBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.WaitForFormCompletion),
  config: WaitForFormCompletionBlockConfigSchema,
});

export type WaitForFormCompletionBlock = z.infer<typeof WaitForFormCompletionBlockSchema>;
